export function initMcToc() {
  const mcToc = document.querySelector('#mc-toc__list');
  if (mcToc === null) return;

  const contentTitles = (
    document.querySelector('.toc-content') ?? document
  ).querySelectorAll<HTMLElement>('h1, h2, h3');

  const tocTopLevel = document.createElement('ol');
  tocTopLevel.classList.add('b-newtoc');

  const [currentList, currentParent] = Array.from(contentTitles).reduce(
    ([currentList, currentParent], title) => {
      const textContent = title.textContent?.trim() ?? '';
      if (title.classList.contains('no_toc') || textContent.length === 0) {
        return [currentList, currentParent] as const;
      }

      title.id ||= titleToId(textContent);

      const tocAnchor = document.createElement('a');
      tocAnchor.classList.add('b-newtoc__link');

      tocAnchor.href = `#${title.id}`;
      tocAnchor.textContent = textContent;
      tocAnchor.dataset.type = title.nodeName;
      const tocLi = document.createElement('li');
      tocLi.appendChild(tocAnchor);

      if (isTopLevelHeading(title)) {
        tocLi.classList.add('b-newtoc__parent');

        //append ul list
        if (currentList.children.length !== 0) {
          currentList.classList.add('b-newtoc__children');
          currentParent?.appendChild(currentList);
          currentList = document.createElement('ul');
        }

        //append ol item
        tocTopLevel.appendChild(tocLi);
        currentParent = tocLi;
      } else {
        //append ul item
        tocLi.classList.add('b-newtoc__child');
        currentList.appendChild(tocLi);
      }

      return [currentList, currentParent] as const;
    },
    [document.createElement('ul'), null as HTMLElement | null] as const,
  );

  //append last ul items to ol
  if (currentList.children.length !== 0) {
    currentList.classList.add('b-newtoc__children');
    currentParent?.appendChild(currentList);
  }

  mcToc.appendChild(tocTopLevel);
}

function isTopLevelHeading(elem: HTMLElement): boolean {
  return 'H1' === elem.nodeName || 'H2' === elem.nodeName;
}

/**
 * Convert the text of a title element to a string suitable for an element id.
 *
 * Characters with diacritics are converted to the nearest ASCII equivalent.
 * Runs of non-alphanumeric characters are replaced with an underscore.
 *
 * @param title Title text to convert
 * @returns id attribute value
 */
function titleToId(title: string): string {
  try {
    return title
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .replace(/\W+/g, '_')
      .toLowerCase();
  } catch {
    return title.replace(/\W+/g, '_').toLowerCase();
  }
}
